import {
  SIGNIN_ENDPOINT,
  SIGNUP_ENDPOINT,
  USER_VERIFICATION_ENDPOINT,
} from './routes';

const request = (
  path: string,
  method: 'POST' | 'GET',
  body?: Record<string, unknown>,
  token?: string,
) => {
  const headers: HeadersInit = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return fetch(path, {
    method,
    headers,
    body: body && JSON.stringify(body),
  });
};

export const signUp = (body: Record<string, unknown>) => {
  return request(SIGNUP_ENDPOINT, 'POST', body);
};

export const signIn = (email: string, password: string) => {
  return request(SIGNIN_ENDPOINT, 'POST', { email, password });
};

export const userVerification = (token: string) => {
  return request(USER_VERIFICATION_ENDPOINT, 'GET', undefined, token);
};
